const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');
const Requirements = require('../model/Requirements');

class StorefrontChannel extends ChannelDefinition {
	id = 'storefront';
	title = 'Storefront';
	description = 'Your NearSt-hosted storefront for showcasing products and store information.';
	category = Categories.OMNICHANNEL_EXPERIENCE;

	iconUrl = 'https://go.near.st/hubfs/channels/nearst.png';
	coverImageUrl = 'https://go.near.st/hubfs/channels/headers/shop-page.png';

	longDescription = `
## Overview
The Storefront is your NearSt-hosted shop page where customers can discover your products, view store information, and connect with your shop through multiple channels.

## How it works
This channel is automatically created for all active NearSt retailers. You can customise your bio, branding, social links and verification codes. The storefront integrates with other channels to provide a seamless shopping experience.
	`;

	manageUrl = '/channels/{shopId}/settings/storefront';
	productSpecificVisibility = false;

	worksWith = ['google', 'product-reservations', 'local-checkout', 'meta-commerce'];

	helpArticleUrls = [
		{
			title: 'Customising your storefront',
			url: 'https://support.near.st/en/articles/6675170'
		}
	];

	requirements = new Requirements({});
}

module.exports = StorefrontChannel;
